var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPlayCircle = function SvgIconPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 124 124"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_play_circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF9A23",
    fillRule: "evenodd",
    d: "M0 62a62 62 0 1 1 124 0A62 62 0 0 1 0 62m51.658-20.104a4.13 4.13 0 0 1 4.134-.017l28.933 16.533a4.133 4.133 0 0 1 0 7.176L55.792 82.12a4.134 4.134 0 0 1-6.192-3.588V45.467a4.13 4.13 0 0 1 2.058-3.572",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_play_circle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h124v124H0z"
  })))));
};
export default SvgIconPlayCircle;